export const ACCESS_TOKEN = "SMS_SERVICES_CUSTOMER";
export const authApi = "http://104.248.99.193:9001/api";
export const dataApi = "https://api.axpigeon.axra.app/api/rest";
/**
 * is logged in cookie
 */
export const test_image = ` https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8cHJvZmlsZSUyMHBpY3R1cmV8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=600&q=60`;
export const IS_LOGGED_IN_KEY = "__JYU^E^WE&E";
export const IS_LOGGED_IN_VALUE = "fd44adYnj544(^5q43)933b763c7049ea844b5";
